if (!window.fbControls) window.fbControls = [];
window.fbControls.push(function (controlClass) {
	class controlImageHolder extends controlClass {
		static get definition() {
			return {
				icon: '<i class="fa fa-picture-o" aria-hidden="true"></i>',
				i18n: {
					default: 'Image'
				}
			};
		}

		configure() { }

		build() {
			return this.markup('img', null, { id: this.config.name, class: this.config.className });
		}

		onRender() {
			if (this.config.value) {
				$("#" + this.config.name).attr('src', this.config.value);
				$("#" + this.config.name).css({'height': 'auto', 'width': '100%'});
				$("#" + this.config.name).attr('alt', this.config.placeholder ? this.config.placeholder : ''); 
			} else if (this.config.userData) {
				$("#" + this.config.name).attr('src', this.config.userData[0]);
				$("#" + this.config.name).css({'height': 'auto', 'width': '100%'});
				$("#" + this.config.name).attr('alt', this.config.placeholder ? this.config.placeholder : ''); 
			} else if (this.config.shape) {
				$("#" + this.config.name).attr('src', this.config.shape);
				$("#" + this.config.name).css({'height': 'auto', 'width': '100%'});
				$("#" + this.config.name).attr('alt', this.config.placeholder ? this.config.placeholder : ''); 
			} else {
				$("#" + this.config.name).attr('src', '');
			}
		}
	}
	controlClass.register('Image', controlImageHolder);
	return controlImageHolder;
});
